<template>
  <div class="material split-screen" :style="{height: `${fullHeight}px`}">
    <div class="color-half">
      <div class="container">
        <p class="page-title">Apply Your Knowledge</p>

        <div class="content" v-if="allDone == false">
          <h2>Building A New Home</h2>
          <p>You will be testing the specific heat capacity of four sample materials to determine which ones you could use.</p>
          <p>The building materials you choose should have a specific heat capacity of at least 1.8 J/g°C.</p>
        </div>


        <div class="content" v-if="allDone == true">
          <h2>Are you up for a real-world challenge?</h2>



          <div class="btn-row">
            <router-link to="/quiz/greater-than" class="btn">Continue &RightArrow;</router-link>
          </div>
        </div>
      </div>
    </div>

    
    <div class="bigger-half">
      <div class="container">
          <div class="material-grid">
            <div @click="goMaybe(material.done, material.id)" 
            class="box" v-for="material of getMaterials" 
            :key="material.id" 
            :class="{'done' : material.done}"
            :style="{pointerEvents: material.done === true ? 'none' : 'auto' }">
              <p class="text">{{ material.text }}</p>
              <Dots :fill="material.fill" :wiggle="material.done === true ? material.wiggle : 0" :w="200" :h="200" :r="material.done === true ? 40 : 200" />
            </div>
          </div>
        </div>
    </div>
      
  </div>
</template>


<script>
import Dots from '../components/Dots'
import { mapGetters } from 'vuex'

export default {
  components:{
    Dots
  },
  data() {
    return {
      allDone: false
    }
  },
  methods: {
    goMaybe(done, id){
      if(done === false) this.$router.push({path:`/quiz/apply-your-knowledge/${id}`, params: {id: id}})
    }
  },
  computed: {
    ...mapGetters(['getMaterials', 'fullHeight'])
  },
  mounted() {
    
    if(this.getMaterials.filter(m => m.done === true).length === this.getMaterials.length) this.allDone = true
  },
}
</script>


<style lang="scss">
.bigger-half .container{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.material-grid{
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 3rem;
  width: 100%;
  max-width: 60rem;
  .box{
    min-height: 16.8rem;
    box-shadow: 2px 2px 5px rgba($dark, 0.5);
    cursor: pointer;

    &.done{
      opacity: 0.6;
    }
    

    .text{
      background: $light;
      margin: 0;
      padding: 1rem;
      margin-bottom: 1rem;
      transition: all 250ms;
    }

    &:hover{
      .text{
        background: $blue;
        color: #ffffff;
      }
    }

    &.picked{
      .text{
        background: $green;
        color: #ffffff;
      }
    }
  }
}
  
</style>